import { graphql } from 'gql';

export const bimUpdateActKC2TotalsGql = graphql(`
    mutation bimUpdateActKC2Totals($workOrderId: Long!, $uploadId: String!, $actsKC2Ids: [Long!]!) {
        bimUpdateActKC2Totals(workOrderId: $workOrderId, uploadId: $uploadId, actsKC2Ids: $actsKC2Ids) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
            data
        }
    }
`);
